import { useState } from "react";
import {
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import { Link } from "react-router-dom";
import classnames from "classnames";

// styles
import useStyles from "./styles";

// components
import Dot from "../Dot";
import { useTranslation } from "react-i18next";

export default function SidebarLink({
  link,
  icon: Icon,
  label,
  children,
  location,
  isSidebarOpened,
  isCollapseOpened,
  nested,
  seller_id,
  type,
}) {
  var classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  // local
  var [isOpen, setIsOpen] = useState(isCollapseOpened);
  var isLinkActive =
    link &&
    (location.pathname === link || location.pathname.indexOf(link) !== -1);

  if (type === "title")
    return (
      <Typography
        className={classnames(classes.linkText, classes.sectionTitle, {
          [classes.linkTextHidden]: !isSidebarOpened,
        })}
      >
        {label}
      </Typography>
    );

  if (type === "divider") return <Divider className={classes.divider} />;
  if (link && link.includes("http")) {
    return (
      <ListItem
        button
        className={classes.link}
        classes={{
          root: classnames(classes.linkRoot, {
            [classes.linkActive]: isLinkActive && !nested,
            [classes.linkNested]: nested,
          }),
        }}
        disableRipple
      >
        <a className={classes.externalLink} href={link}>
          <ListItemIcon
            className={classnames(classes.linkIcon, {
              [classes.linkIconActive]: isLinkActive,
            })}
          >
            {nested ? <Dot color={isLinkActive && "primary"} /> : <Icon />}
          </ListItemIcon>
          <ListItemText
            classes={{
              primary: classnames(classes.linkText, {
                [classes.linkTextActive]: isLinkActive,
                [classes.linkTextHidden]: !isSidebarOpened,
              }),
            }}
            primary={t(label)}
          />
        </a>
      </ListItem>
    );
  }
  if (!children?.length)
    return (
      <ListItem
        button
        component={link && Link}
        to={link}
        className={classes.linkNestedBg}
        classes={{
          root: classnames(
            classes.linkRoot,
            {
              [classes.linkActive]: isLinkActive && !nested,
              [classes.linkNested]: nested,
              [classes.linkNestedActive]: isLinkActive && nested,
            },
            seller_id === 2 && classes.notNestedMargin,
          ),
        }}
        disableRipple
      >
        <ListItemIcon className={classnames(classes.linkIconDesktopNested)}>
          <Icon
            color={
              isLinkActive
                ? theme.palette.colors.dark_icon
                : theme.palette.colors.light_icon
            }
          />
        </ListItemIcon>
        <ListItemText
          classes={{
            primary: classnames(classes.linkTextInner, {
              [classes.linkTextActive]: isLinkActive,
              [classes.linkTextHidden]: !isSidebarOpened,
            }),
          }}
          primary={t(label)}
        />
      </ListItem>
    );

  return (
    <>
      <ListItem
        button
        component={link && Link}
        onClick={toggleCollapse}
        className={classnames(classes.mainMenu, classes.link, {
          [classes.mainMenuOpen]: isOpen,
        })}
        to={link}
        disableRipple
      >
        <ListItemIcon
          className={classnames(classes.linkIcon, {
            [classes.linkIconActive]: isLinkActive,
          })}
        >
          <Icon color={theme.palette.colors.white} />
        </ListItemIcon>
        <ListItemText
          classes={{
            primary: classnames(classes.linkText, {
              [classes.linkTextActive]: isLinkActive,
              [classes.linkTextHidden]: !isSidebarOpened,
            }),
          }}
          primary={t(label)}
        />
      </ListItem>
      {children && (
        <Collapse
          in={isOpen && isSidebarOpened}
          timeout="auto"
          unmountOnExit
          className={classes.nestedList}
        >
          <List component="div" disablePadding>
            {children.map((childrenLink) => (
              <SidebarLink
                key={childrenLink && childrenLink.link}
                location={location}
                isSidebarOpened={isSidebarOpened}
                classes={classes}
                nested
                {...childrenLink}
              />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
  function toggleCollapse(e) {
    if (isSidebarOpened) {
      e.preventDefault();
      setIsOpen(!isOpen);
    }
  }
}
